export default "__VITE_ASSET__BvVoA79g__"